export const BASE_URL = client_info.base_url;
export const OAUTH_CLIENT_ID = client_info.oauth_client_id;
export const OAUTH_CLIENT_SECRET = client_info.oauth_client_secret;
export const OAUTH_REDIRECT_URI = client_info.oauth_redirect_uri;
export const AUTH_URL = client_info.auth_url;
export const DATA_URL = client_info.data_url;